import React from "react";
import { Instagram, MapPin, Phone } from "lucide-react";
import Logo from "./Logo";
import { clinic, navLinks, whatsappLink, mapsLink } from "../mock";

const Footer = () => {
  const addr = clinic.address;
  return (
    <footer className="brand-grad text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid md:grid-cols-3 gap-12">
          <div>
            <Logo variant="light" />
            <p className="text-[#94a7b8] mt-5 leading-relaxed text-sm max-w-xs">
              Centro oftalmológico especializado no cuidado completo da sua visão em
              João Pessoa - PB.
            </p>
            <a
              href={clinic.instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 mt-5 text-sm text-white hover:text-[#b89a5a] transition-colors"
            >
              <Instagram className="w-5 h-5" /> @{clinic.instagram}
            </a>
          </div>

          <div>
            <h4 className="font-display font-semibold text-lg">Navegação</h4>
            <div className="gold-line mt-3 mb-4" />
            <ul className="space-y-2.5">
              {navLinks.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-[#94a7b8] hover:text-white transition-colors text-sm">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display font-semibold text-lg">Contato</h4>
            <div className="gold-line mt-3 mb-4" />
            <a href={mapsLink} target="_blank" rel="noopener noreferrer" className="flex items-start gap-3 text-[#94a7b8] hover:text-white transition-colors text-sm">
              <MapPin className="w-5 h-5 shrink-0 mt-0.5 text-[#b89a5a]" />
              <span>
                {addr.building}<br />
                {addr.street}, {addr.room}<br />
                {addr.district}, {addr.city}-{addr.state}<br />
                CEP: {addr.cep}
              </span>
            </a>
            <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 mt-4 text-[#94a7b8] hover:text-white transition-colors text-sm">
              <Phone className="w-5 h-5 text-[#b89a5a]" /> {clinic.phone}
            </a>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-[#94a7b8] text-sm">
            © {new Date().getFullYear()} Foco Vision — Centro Oftalmológico. Todos os direitos reservados.
          </p>
          <p className="text-[#94a7b8] text-sm">João Pessoa - PB</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
